import { url_prefix as prefix } from '../config';
import types from './types';

export function getCountries() {
  return {
    types: [
      types.GET_COUNTRIES_REQUEST,
      types.GET_COUNTRIES_SUCCESS,
      types.GET_COUNTRIES_FAILURE
    ],
    ajax: {
      url: prefix + '/countries',
      data: {
        checkout_enabled: 1,
        orderBy: 'country_name',
      }
    }
  };
}
